import { FC } from 'react';
import { useMutation } from '@apollo/client';
import ConfirmDialog from 'components/common/Dialog/ConfirmDialog';
import { DELETE_SECRET, SECRETS_DATA } from '../queries';
import { SecretAndDeselect } from '../types';

import '../styles.scss';

type DeleteSecretDialogProps = {
  deleteSecretDialogIsOpen: boolean;
  setDeleteSecretDialogIsOpen: (open: boolean) => void;
  handleChange: () => void;
} & SecretAndDeselect;

/**
 *
 * A dialog that Deletes Secrets
 *
 */
const DeleteSecretDialog: FC<DeleteSecretDialogProps> = ({
  handleChange,
  selectedSecret,
  deselectSecret,
  deleteSecretDialogIsOpen,
  setDeleteSecretDialogIsOpen,
}) => {
  const [deleteSecret] = useMutation(DELETE_SECRET, { refetchQueries: [SECRETS_DATA] });
  const onDialogSubmit = (): void => {
    if (selectedSecret) {
      deleteSecret({ variables: { name: selectedSecret.name } });
      handleChange();
    }
  };
  const onClose = (): void => {
    setDeleteSecretDialogIsOpen(false);
    deselectSecret();
  };
  if (selectedSecret) {
    const deleteText = `Delete "${selectedSecret.name}" Secret?`;
    return (
      <ConfirmDialog
        title="Delete Secret"
        text={deleteText}
        show={deleteSecretDialogIsOpen}
        close={onClose}
        onSubmit={onDialogSubmit}
      />
    );
  }
  return null;
};

export default DeleteSecretDialog;
